import { render, staticRenderFns } from "./CommandeList.vue?vue&type=template&id=74523666&"
import script from "./CommandeList.vue?vue&type=script&lang=js&"
export * from "./CommandeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports